import { forEach } from "underscore";
import { t } from "../../utils/i18n";

export const urlRegex = new RegExp(
  "^(https?:\\/\\/)?" + // protocol
  "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
  "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
  "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
  "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    "(\\#[-a-z\\d_]*)?$",
  "i"
); // fragment locator

const bananacrystal_names = ["BananaCrystal", "Banana Crystal"];

export const required = value => {
  if (!value) {
    return t("store_integrations.validations.required");
  }
};

export const url = value => {
  if (!value) {
    return t("store_integrations.validations.required");
  } else if (!value.match(urlRegex)) {
    return t("store_integrations.validations.invalid_url", { value });
  }
};

export const multipleUrls = value => {
  if (!value) {
    return t("store_integrations.validations.required");
  } else {
    let urls = value.split(" ")
    let invalidUrls=0;
    urls.forEach(url => {
      if (url && !url.match(urlRegex)) {
        invalidUrls++;
      }
    });
    if (invalidUrls > 0) {
      return  t("store_integrations.validations.contains_invalid_url");
    }
  } 
}

export const validateName = value => {
  if (!value) {
    return t("store_integrations.validations.required");
  } else if (bananacrystal_names.includes(value)) {
    return t("store_integrations.validations.name_bananacrystal");
  }
}